import { useState } from 'react';
import { useFirm } from 'hooks/data/firm/useFirm';

export type FirmOption = {
  _id: string;
  firmName: string;
};

export enum OrgUserFirmAccessType {
  All = 'all',
  Specific = 'specific',
}

export function useOrgUserFirmAccess() {
  const [firmAccess, setFirmAccessState] = useState<OrgUserFirmAccessType>(
    OrgUserFirmAccessType.All,
  );
  const [selectedFirms, setSelectedFirms] = useState<Array<FirmOption>>([]);

  const { firms } = useFirm({ params: {} });
  const eisFirms = firms.data?.result?.filter((firm) => !firm.isLpFirm) ?? [];

  const setFirmAccess = (value: OrgUserFirmAccessType) => {
    setFirmAccessState(value);
    if (value === OrgUserFirmAccessType.All) {
      setSelectedFirms([]);
    }
  };

  const reset = (hasAllFirmsAccess: boolean, firmIds: Array<FirmOption>) => {
    setFirmAccessState(
      hasAllFirmsAccess
        ? OrgUserFirmAccessType.All
        : OrgUserFirmAccessType.Specific,
    );
    setSelectedFirms(firmIds);
  };

  return {
    firmAccess,
    setFirmAccess,
    selectedFirms,
    setSelectedFirms,
    eisFirms,
    reset,
    hasAllFirmsAccess: firmAccess === OrgUserFirmAccessType.All,
    firmIds: selectedFirms.map((f) => f._id),
  };
}
